<template>
  <page :title="i18n.download">
    <div class="download-content">
      <div class="img_logo">
        <img src="../../assets/imgs/img_logo.png" alt="" />
      </div>
      <div class="tips">{{ i18n.download_tips }}</div>
      <div class="downloadbtn btn" @click="onDownload">
        <span>{{ i18n.download }}</span>
      </div>
    </div>
  </page>
</template>

<script>
import { mapState } from "vuex"
export default {
  watch: {},
  computed: {
    ...mapState(["system"]),
    i18n() {
      return this.$t("result")
    },
    i18nMsg() {
      return this.$t("msg")
    }
  },
  data() {
    return {
      downloadApp: false
    }
  },
  methods: {
    onDownload() {
      let dowmloadUrl = process.env.VUE_APP_GOOGLE_PLAY
      if (this.system === "ios") {
        dowmloadUrl = process.env.VUE_APP_APP_STORE
      }
      if (dowmloadUrl) {
        window.open(dowmloadUrl)
      } else {
        this.$toast(this.i18nMsg.appoffline)
      }
    }
  }
}
</script>

<style lang="less">
.download-content {

  .unlocked {
    max-width: 30%;
    display: block;
    margin: 0px auto;
    padding: 50px 0 0;
  }

  h2 {
    font-size: 52px;
    font-family: "Montserrat-SemiBold";
    font-weight: bold;
    text-align: center;
    margin: 0;
    padding: 40px 0;
  }

  .img_logo {
    padding-top: 120px;
    img {
      display: block;
      margin: 0 auto;
      width: 40%;
      margin-bottom: 40px;
    }
  }

  .tips {
    line-height: 1.8;
    font-size: 28px;
    // color: #000;
    text-align: center;
    margin: 20px 60px 40px;
  }

  .downloadbtn {
    margin: 18vh 56px 56px;
  }
}
</style>
